import React from "react";
import { WhmAvatar, WhmGrid, WhmTypography } from "@securitize/reactjs-whm";
import { DocumentDto } from "../../../../data/types";
import {
  translationKeys,
  useTranslation,
} from "../../../../hooks/useTranslation";

interface Props {
  document: DocumentDto;
}
export const RelatedCell: React.FC<Props> = ({ document }) => {
  const { getTranslation: t } = useTranslation();

  const { tokenName, tokenLogoUrl } = document;

  return (
    <WhmGrid
      display="flex"
      wrap="nowrap"
      direction="row"
      height="100%"
      alignItems="center"
      gap={2}
    >
      {tokenName && (
        <>
          <WhmAvatar
            alt={tokenName}
            src={tokenLogoUrl}
            sx={{ width: 24, height: 24 }}
          />
          <WhmTypography variant="body2">{tokenName}</WhmTypography>
        </>
      )}
      {!tokenName && (
        <WhmTypography variant="body2">
          {t(translationKeys.DOCUMENT_RELATED_BY_MULTIPLE)}
        </WhmTypography>
      )}
    </WhmGrid>
  );
};
